/**
 * API base URL, in its own module so `lib/auth/api.ts` can use it without
 * importing the request client (which depends on auth — that would cycle).
 *
 * Defaults to a same-origin `/api/v1`, which the Vite dev proxy forwards to
 * the backend and which keeps the service worker's BackgroundSync route
 * (`/api/`) matching. Deployed builds point straight at the API host and rely
 * on the server's CORS allowlist instead.
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
